import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';
import { BookOpen } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LeaveLedger() {
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLedger();
  }, []);

  const fetchLedger = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/leaves/ledger`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLedger(response.data);
    } catch (error) {
      toast.error('Failed to load leave ledger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="space-y-8" data-testid="leave-ledger-page">
        <div>
          <h1 className="text-4xl font-bold tracking-tight">Leave Ledger</h1>
          <p className="text-muted-foreground mt-2">Track your paid leave usage history</p>
        </div>

        <Card data-testid="ledger-card">
          <CardHeader>
            <CardTitle className="flex items-center">
              <BookOpen className="mr-2 h-5 w-5" />
              Leave Transaction History
            </CardTitle>
            <CardDescription>Complete record of your leave credits and usage</CardDescription>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="text-center py-8">Loading...</div>
            ) : ledger.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                No leave records found
              </div>
            ) : (
              <div className="w-full overflow-auto rounded-lg border border-border">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Date</TableHead>
                      <TableHead>Description</TableHead>
                      <TableHead className="text-right">Leaves Used</TableHead>
                      <TableHead className="text-right">Leaves Credited</TableHead>
                      <TableHead className="text-right font-bold">Balance</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {ledger.map((entry, index) => (
                      <TableRow key={index} data-testid="ledger-row">
                        <TableCell className="font-medium">{entry.date}</TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell className="text-right text-red-600">
                          {entry.leaves_used > 0 ? `-${entry.leaves_used}` : '-'}
                        </TableCell>
                        <TableCell className="text-right text-green-600">
                          {entry.leaves_credited > 0 ? `+${entry.leaves_credited}` : '-'}
                        </TableCell>
                        <TableCell className="text-right font-bold">{entry.balance}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
